import { tryCatchHelper } from '../../../helpers';
import {
  ACTIVO_EVALUACIONES,
  ALL_EVALUACIONES,
  LOADING_ALL_EVALUACIONES,
} from './EvaluacionesReducer';
import {
  deleteEvaluacionesService,
  allEvaluacionesService,
  oneEvaluacionesService,
  saveEvaluacionesService,
} from './EvaluacionesService';

export const allEvaluacionesAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_EVALUACIONES, payload: true });
    const res = await allEvaluacionesService(params);
    dispatch({ type: ALL_EVALUACIONES, payload: res.data });
    dispatch({ type: LOADING_ALL_EVALUACIONES, payload: false });
    return res.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_EVALUACIONES, payload: false });
    tryCatchHelper(e);
    return false;
  }
};

export const saveEvaluacionesAction = async (
  { dispatch, notify },
  id,
  data,
  params,
) => {
  try {
    const res = await saveEvaluacionesService(id, data);
    notify(res.data.message);
    await allEvaluacionesAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoEvaluacionesAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_EVALUACIONES, payload: data });
};

export const oneEvaluacionesAction = async (dispatch, id) => {
  try {
    const res = await oneEvaluacionesService(id);
    await setActivoEvaluacionesAction(dispatch, res.data.data);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const deleteEvaluacionesAction = async (
  { dispatch, notify },
  id,
  params,
) => {
  try {
    const res = await deleteEvaluacionesService(id);
    notify(res.data.message);
    await setActivoEvaluacionesAction(dispatch, null);
    await allEvaluacionesAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};
